import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b41f6cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "value"]
const _hoisted_2 = { value: "" }
const _hoisted_3 = ["value"]

import { withDefaults } from 'vue'
import { t } from '@/i18n'

export interface Option {
  label: string | number
  value: string | number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    disabledOptionText: { default: t('meta.pleaseSelect') },
    options: null,
    disabled: { default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue?: string | number | null, disabledOptionText: string, options?: Array<Option>, disabled: boolean }





const onChange = (event: Event) => {
  const target = event.target as HTMLSelectElement
  if (target) {
    emit('update:modelValue', target.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["select-wrap", { 'select-wrap--disabled': props.disabled }])
  }, [
    _createElementVNode("select", {
      class: "select",
      disabled: props.disabled,
      value: props.modelValue,
      onChange: onChange
    }, [
      _createElementVNode("option", _hoisted_2, _toDisplayString(props.disabledOptionText), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (item) => {
        return (_openBlock(), _createElementBlock("option", {
          key: item.value,
          value: item.value
        }, _toDisplayString(item.label), 9, _hoisted_3))
      }), 128))
    ], 40, _hoisted_1)
  ], 2))
}
}

})